import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Login20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.0001 2.06065L5.53039 6.53032L4.46973 5.46966L9.11617 0.823209C9.60433 0.335053 10.3958 0.335054 10.8839 0.823209L19.1768 9.1161C19.665 9.60426 19.665 10.3957 19.1768 10.8839L10.8839 19.1768C10.3958 19.6649 9.60433 19.6649 9.11617 19.1768L4.46973 14.5303L5.53039 13.4697L10.0001 17.9393L17.9394 9.99999L10.0001 2.06065Z'
      fill='currentColor'
    />
    <path
      d='M11.1894 10.75H1V9.25H11.1894L8.96973 7.03033L10.0304 5.96967L14.0607 10L10.0304 14.0303L8.96973 12.9697L11.1894 10.75Z'
      fill='currentColor'
    />
  </Svg>
);

Login20.displayName = 'Login20';
export default Login20;
